"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Styles = require("../utils/Styles");

var _NormalColors = _interopRequireDefault(require("../core/NormalColors"));

var _colors = require("HubStyleTokens/colors");

var _internal = require("./internal");

var BADGE_COLORS = {
  pantera: _colors.PANTERA,
  koala: _colors.KOALA,
  beta: _colors.THUNDERDOME,
  default: _colors.LORAX,
  free: _colors.LORAX,
  new: _colors.OZ,
  none: null
};
var COUNT_BADGES = {
  count: null,
  dot: null
};
var BADGE_USES = Object.assign({}, _NormalColors.default, {}, BADGE_COLORS, {}, COUNT_BADGES);
var DEFAULT_BADGE_USE = 'free';

var colorStylesMixin = function colorStylesMixin(props) {
  var backgroundColor = BADGE_USES[props.use] || BADGE_USES[DEFAULT_BADGE_USE];
  return (0, _styledComponents.css)(["background-color:", ";color:", ";"], backgroundColor, backgroundColor === _colors.KOALA ? _colors.OBSIDIAN : _colors.OLAF);
};

var NOTIFICATION_BADGE_BORDER_WIDTH = '1px';
var NOTIFICATION_BADGE_DEFAULT_SIZE = '21px';
var NOTIFICATION_BADGE_FONT_SIZE = '11px';
var NOTIFICATION_BADGE_SMALL_SIZE = '10px';
var COMPUTED_LINE_HEIGHT = (0, _Styles.toPx)(parseInt(NOTIFICATION_BADGE_DEFAULT_SIZE, 10) - parseInt(NOTIFICATION_BADGE_BORDER_WIDTH, 10) * 2);

var StyledBadge = _styledComponents.default.span.withConfig({
  displayName: "UIBadge__StyledBadge",
  componentId: "tv06od-0"
})(["", ";", ";padding:0 8px;"], _internal.badgeStylesMixin, colorStylesMixin);

var countStyles = "\n  " + _Styles.FONT_FAMILIES.demibold() + ";\n  font-size: " + NOTIFICATION_BADGE_FONT_SIZE + ";\n  " + (0, _Styles.setFontSmoothing)('antialiased') + ";\n  border-radius: 500px;\n  color: " + _colors.OLAF + ";\n  line-height: " + COMPUTED_LINE_HEIGHT + ";\n  min-height: " + NOTIFICATION_BADGE_DEFAULT_SIZE + ";\n  min-width: " + NOTIFICATION_BADGE_DEFAULT_SIZE + ";\n  padding: 0 4px;\n";
var dotStyles = "\n  border-radius: 100%;\n  height: " + NOTIFICATION_BADGE_SMALL_SIZE + ";\n  text-indent: -1000rem;\n  width: " + NOTIFICATION_BADGE_SMALL_SIZE + ";\n";

var CountBadge = _styledComponents.default.span.withConfig({
  displayName: "UIBadge__CountBadge",
  componentId: "tv06od-1"
})(["background-color:", ";border:", " solid ", ";box-shadow:0 0 0 ", " ", ";display:inline-block;pointer-events:none;text-align:center;vertical-align:baseline;", ";", ";"], _colors.NORMAN, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, NOTIFICATION_BADGE_BORDER_WIDTH, _colors.OLAF, function (props) {
  return props.use === 'count' ? countStyles : null;
}, function (props) {
  return props.use === 'dot' ? dotStyles : null;
});

var UIBadge = function UIBadge(_ref) {
  var children = _ref.children,
      className = _ref.className,
      use = _ref.use,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "className", "use"]);
  var RenderedBadge = !(use === 'count' || use === 'dot') ? StyledBadge : CountBadge;
  var computedClassName = (0, _classnames.default)(className, {
    'private-badge': !(use === 'count' || use === 'dot'),
    'private-badge--count': use === 'count',
    'private-badge--dot': use === 'dot'
  });
  return _react.default.createElement(RenderedBadge, Object.assign({}, rest, {
    className: computedClassName,
    use: use
  }), children);
};

UIBadge.propTypes = {
  children: _propTypes.default.node.isRequired,
  use: _propTypes.default.oneOf(Object.keys(BADGE_USES))
};
UIBadge.defaultProps = {
  use: DEFAULT_BADGE_USE
};
UIBadge.displayName = 'UIBadge';
var _default = UIBadge;
exports.default = _default;
module.exports = exports.default;